import { render, staticRenderFns } from "./employee-history.component.vue?vue&type=template&id=07a72ea0&scoped=true&"
import script from "./employee-history.component.vue?vue&type=script&lang=ts&"
export * from "./employee-history.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-history.component.vue?vue&type=style&index=0&id=07a72ea0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a72ea0",
  null
  
)

export default component.exports